export default "__VITE_ASSET__DzSHdiyl__"